import { ProjectCardI } from "./card";

export const ProjectList: ProjectCardI[] = [
  {
    title: "Javascript / Typescript",
    description: "Express, Nestjs, React, React Native, Vue",
  },
  {
    title: "AI tools",
    description: "Anthropic (Claude), OpenAI (chatGPT), GCP DocumentAi",
  },
  {
    title: "ML Predictive Maintenance Algorithms with TensorFlow",
    description:
      "Development of Predictive Maintenance Algorithms and RAGs with Anthropic and OpenAI",
  },
  {
    title: "Development of RestAPI as Microservices",
    description: "Development of microservices using patterns like DDD ",
  },
  {
    title: "API Integrations",
    description:
      "Integration with 3th party applications such as, google services (documentAi, gdocs, calendar, gmail), mercado livre, stripe, sendgrid and Anthropic so on.",
  },
  {
    title: "Crawlers and Scrapers",
    description:
      "Crawlers to fetch complex data form different sources, eg: linkedin, youtube, google...",
  },
  {
    title: "Single Sign-On",
    description:
      "Development of a SSO to enable the end user to access several related, yet completely independent applications, belonging to the same company.",
  },
  {
    title: "Payment Services Integration",
    description: "Integration with Stripe payment service",
  },
  {
    title: "RabbitMQ Queue message services",
    description:
      "Configuration and development of consumer and producer flows for RabbitMQ",
  },
  {
    title: "Multiple React Native MVPs",
    description: "Development of multiple react native MVPs",
  },
  {
    title: "Mongodb Database modeling",
    description:
      "Bussiness analysis and database modeling for a scalable database structure",
  },
  {
    title: "Data normalization and migration",
    description:
      "Data normalization and migration between mysql > psql and mongodb > MSsql",
  },
  {
    title: "CI/CD",
    description:
      "Configuration of CI/CD pipelines using GCP Cloud Build and GitHub Actions",
  },
  {
    title: "GCP - Google Cloud Run",
    description:
      "Creation and configuration of google cloud run instances to deploy services",
  },
];
